import type * as M from "../../ManagedRuntime.js"

// circular with Layer

/** @internal */
export const TypeId: M.TypeId = Symbol.for("effect/ManagedRuntime") as M.TypeId
